import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND, EMAIL, PHONE_DISPLAY, PHONE_TEL } from '../constants/brand';
import { CORE_CITIES, METRO_CITIES } from '../data/cities';
import { NAV_SERVICES } from '../data/services';
import { locationPath, ROUTES, servicePath } from '../enum/routes';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <>
      <footer className="border-t border-black/5 bg-ink pb-24 pt-16 text-white/85 sm:pb-16">
        <div className="container-page grid grid-cols-2 gap-8 sm:gap-10 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <Link className="site-logo site-logo--on-dark" to={ROUTES.HOME}>
              <img src="/assets/img/logo.png" alt={BRAND} width={132} height={116} />
            </Link>
            <p className="mt-4 max-w-xs text-sm text-white/75">Making the first step of your next home project easier.</p>
            <Link className="btn-primary mt-5 !py-2 !text-sm" to={ROUTES.QUOTE}>
              Get a Free Quote
            </Link>
          </div>
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-white">Services</h3>
            <ul className="mt-4 space-y-2 text-sm">
              {NAV_SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link className="text-white/80 hover:text-white" to={servicePath(s.slug)}>
                    {s.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link className="text-white/80 hover:text-white" to={ROUTES.SERVICES}>
                  All services →
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-white">Browse by City</h3>
            <ul className="mt-4 space-y-2 text-sm">
              {CORE_CITIES.map((c) => (
                <li key={c.slug}>
                  <Link className="text-white/80 hover:text-white" to={locationPath(c.slug)}>
                    {c.name}
                  </Link>
                </li>
              ))}
              {METRO_CITIES.slice(0, 2).map((c) => (
                <li key={c.slug}>
                  <Link className="text-white/80 hover:text-white" to={locationPath(c.slug)}>
                    {c.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link className="text-white/80 hover:text-white" to={ROUTES.SERVICE_AREAS}>
                  All areas →
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-white">Contact</h3>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a href={`tel:${PHONE_TEL}`} className="font-semibold text-white hover:text-white/80">
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} className="text-white/80 hover:text-white">
                  {EMAIL}
                </a>
              </li>
              <li className="text-white/70">8am-9pm · 7 days a week</li>
            </ul>
          </div>
        </div>
        <div className="container-page mt-12 border-t border-white/10 pt-6">
          <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
            <nav className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs">
              <Link className="text-white/70 hover:text-white" to={ROUTES.ABOUT}>
                About Us
              </Link>
              <Link className="text-white/70 hover:text-white" to={ROUTES.QUOTE}>
                Contact
              </Link>
              <Link className="text-white/70 hover:text-white" to={ROUTES.PRIVACY}>
                Privacy Policy
              </Link>
              <Link className="text-white/70 hover:text-white" to={ROUTES.TERMS}>
                Terms &amp; Conditions
              </Link>
            </nav>
            <p className="text-xs text-white/60">
              © {year} {BRAND}.
            </p>
          </div>
        </div>
      </footer>
      <div className="mobile-cta fixed inset-x-0 bottom-0 z-30 border-t border-black/10 bg-white/95 backdrop-blur md:hidden">
        <div className="grid grid-cols-2 gap-2 p-2">
          <a href={`tel:${PHONE_TEL}`} className="btn-secondary w-full !py-2.5 !text-sm">
            Call Now
          </a>
          <Link className="btn-primary w-full !py-2.5 !text-sm" to={ROUTES.QUOTE}>
            Get a Free Quote
          </Link>
        </div>
      </div>
    </>
  );
}
